const DISNEYLANDLANDS = [

    {
        name: 'Adventureland',
        rides: [
            {
                name: 'Indiana Jones Adventure',
                count: 0,
            },
            {
                name: 'Enchanted Tiki Room',
                count: 0,
            }
        ]
    },

    {
        name: 'Critter Country',
        rides: [
            {
                name: "Davy Crockett's Explorer Canoes",
                count: 0,
            }
        ]
    },

    {
        name: 'Fantasyland',
        rides: [
            {
                name: "It's a Small World",
                count: 0,
            },
            {
                name: 'Alice in Wonderland',
                count: 0,
            },
            {
                name: 'Bibbidi Bobbidy Boutique',
                count: 0,
            },
            {
                name: 'Casey Jr. Circus Train',
                count: 0,
            },
            {
                name: 'Dumbo the Flying Elephant',
                count: 0,
            },
            {
                name: 'King Arthur Carousel',
                count: 0,
            },
            {
                name: 'Matterhorn Bobsleds',
                count: 0,
            },
            {
                name: "Mr. Toad's Wild Ride",
                count: 0,
            },
            {
                name: "Peter Pan's Flight",
                count: 0,
            },
            {
                name: "Pinocchio's Daring Journey",
                count: 0,
            },
            {
                name: 'Sleeping Beauty Castle Walkthrough',
                count: 0,
            },
            {
                name: 'Storybook Land Canal Boats',
                count: 0,
            }
        ]
    },

    {
        name: 'Frontierland',
        rides: [
            {
                name: 'Big Thunder Mountain Railroad',
                count: 0,
            },
            {
                name: 'Fantasmic!',
                count: 0,
            }
        ]
    },

    {
        name: 'Main Street U.S.A',
        rides: [
            {
                name: 'Disneyland Railroad Main Street Station',
                count: 0,
            },
            {
                name: 'Main Street Cinema',
                count: 0,
            },
            {
                name: 'Great Moments with Mr. Lincoln',
                count: 0,
            }
        ]
    },

    {
        name: 'Toontown',
        rides: [
            {
                name: "Roger Rabbit's Car Toon Spin",
                count: 0,
            }
        ]
    },

    {
        name: 'New Orleans Square',
        rides: [
            {
                name: 'Haunted Mansion',
                count: 0,
            },
            {
                name: 'Pirates of the Caribbean',
                count: 0,
            }
        ]
    },

    {
        name: "Star Wars: Galaxy's Edge",
        rides: [
            {
                name: 'Droid Depot',
                count: 0,
            },
            {
                name: 'Millenium Falcon: Smugglers Run',
                count: 0,
            },
            {
                name: "Savi's Workshop",
                count: 0,
            },
            {
                name: 'Star Wars: Rise of the Resistance',
                count: 0,
            }
        ]
    },

    {
        name: 'Tomorrowland',
        rides: [
            {
                name: 'Astro Orbitor',
                count: 0,
            },
            {
                name: 'Autopia',
                count: 0,
            },
            {
                name: 'Buzz Lightyear Astro Blasters',
                count: 0,
            },
            {
                name: 'Disneyland Monorail',
                count: 0,
            },
            {
                name: 'Finidng Nemo Submarine Voyage',
                count: 0,
            },
            {
                name: 'Space Mountain',
                count: 0,
            }
        ]
    },
];

export default DISNEYLANDLANDS;